import React from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip
} from '@mui/material';
import {
  Business as BusinessIcon,
  FreeBreakfast as FreeIcon,
  Star as BasicIcon,
  Diamond as AdvanceIcon
} from '@mui/icons-material';

const PlanFilter = ({ value, onChange, label = "Plan Type", fullWidth = true }) => {
  const planTypeOptions = [
    { 
      value: 'all', 
      label: 'All Plans', 
      icon: <BusinessIcon />,
      description: 'Show all plan types'
    },
    { 
      value: 'free', 
      label: 'Free', 
      icon: <FreeIcon />,
      description: 'Basic plan with limited features',
      color: 'default'
    },
    { 
      value: 'basic', 
      label: 'Basic', 
      icon: <BasicIcon />,
      description: 'Standard plan for growing businesses',
      color: 'primary'
    },
    { 
      value: 'advance', 
      label: 'Advance', 
      icon: <AdvanceIcon />,
      description: 'Premium plan for enterprise needs',
      color: 'secondary'
    }
  ];

  const getSelectedOption = () => {
    return planTypeOptions.find(option => option.value === value) || planTypeOptions[0];
  };

  return (
    <FormControl fullWidth={fullWidth}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        label={label}
        renderValue={(selectedValue) => {
          const option = getSelectedOption();
          return (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              {option.icon}
              <span>{option.label}</span>
            </Box>
          );
        }}
      >
        {planTypeOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {option.icon}
                <span>{option.label}</span>
              </Box>
              {option.value !== 'all' && (
                <Chip 
                  label={option.value.toUpperCase()} 
                  color={option.color} 
                  size="small" 
                  sx={{ ml: 'auto' }}
                />
              )}
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default PlanFilter; 